export default __webpack_public_path__ + "static/media/whatsapp.9145d7d3.png";